
import { useCallback, useMemo, useState } from "react";
import { isLineMeasurement, LineMeasurement, Measurement } from "../../../data/Measurements/Measurement"
import { Point } from "../Geometry";
import { useMeasurement } from "../../../providers/NewMeasurementProvider";
import { useCanvasViewport } from "../CanvasViewportContext";
import { LineMeasurementRepresentation } from "./LineMeasurementRepresentation";

/**
 * Renders the measurements on the canvas.
 */
export function MeasurementsRenderer() {
  const { focusedKeys } = useCanvasViewport();
  const { drawableMeasurements } = useMeasurement();

  const lineMeasurements = useMemo(() => {
    return drawableMeasurements.filter(isLineMeasurement);
  }, [drawableMeasurements]);

  return (
    <svg className="w-full h-full">
      {lineMeasurements.filter(m => focusedKeys ? focusedKeys.includes(m.key) : true).map((measurement) => (
        <LineMeasurementRepresentation key={measurement.key} measurement={measurement} />
      ))}
    </svg>
  );
}